import * as Core from '@gongxigames/framework/core';
import {
    ComponentModuleConfig,
    ComponentModuleViewConfig,
    ComponentsConfigs,
    disabledComponentByDefault,
    EventBridge
} from '@gongxigames/framework/core';
import {Logic} from '@gongxigames/framework/slot/services/logic';
import {TemplateUtils} from '@gongxigames/framework/slot/services/TemplateUtils';
import {ResourceManager} from '@gongxigames/framework/slot/services/ResourcesManager';
import {SoundManager} from '@gongxigames/framework/slot/services/SoundManager';
import {SoundPlayer} from '@gongxigames/framework/slot/services/SoundPlayer';
import {WinPresentationUtils} from '@gongxigames/framework/slot/services/WinPresentationUtils';
import {ReelsScaleService} from '@gongxigames/framework/slot/services/ReelsScaleService';
import {PixiJSDevtoolsService} from '@gongxigames/framework/slot/services/PixiJSDevtoolsService';
import {AutotestService} from '@gongxigames/framework/slot/services/AutotestService';
import {LoggerService} from '@gongxigames/framework/slot/services/LoggerService';
import {SplashScreenService} from '@gongxigames/framework/slot/services/SplashScreenService';
import {ReelsConstantsService} from '@gongxigames/framework/slot/services/ReelsConstantsService';
import {InitializationEnvironmentSettingsService} from '@gongxigames/framework/slot/services/InitializationEnvironmentSettingsService';
import {PrizeSymbolsUtils} from '@gongxigames/framework/slot/services/PrizeSymbolsUtils';
import * as Modules from '@gongxigames/framework/slot/modules';
import {GameRules} from '@gongxigames/framework/slotV2/modules/gameRules';
import {InfoPage} from '@gongxigames/framework/slotV2/modules/infopage';
import {InfoSystemModule} from '@gongxigames/framework/slotV2/modules/infoSystem';
import {ScaleService} from '@gongxigames/framework/slot/services/ScaleService';
import {SLOT_V2_SERVICES} from '@gongxigames/framework/slotV2/services/index';
import {SLOT_V2_UI_SERVICES} from '@gongxigames/framework/slotV2/ui/services';
import {LoadingScreenModuleV2} from '@gongxigames/framework/slotV2/modules/loadingScreenV2';
import {GenericPopupModuleV2} from '@gongxigames/framework/slotV2/modules/genericPopup/GenericPopupModuleV2';
import {WaitingModuleV2} from '@gongxigames/framework/slotV2/modules/waiting/WaitingModuleV2';
import {GameHistoryInfoPage} from '@gongxigames/framework/slotV2/modules/gameHistory/GameHistoryInfoPage';
import {BigWinModuleV2} from '@gongxigames/framework/slotV2/modules/bigwin/BigWinModuleV2';
import {AnticipatorModuleV2} from '@gongxigames/framework/slotV2/modules/anticipator/AnticipatorModuleV2';
import {BuyFeatureModule} from '@gongxigames/framework/slotV2/modules/buyFeature/BuyFeatureModule';
import {GameInfoService} from '@gongxigames/framework/slot/services/GameInfoService';
import {
    JurisdictionZoneDataService
} from '@gongxigames/framework/slotV2/services/JurisdictionZoneData/JurisdictionZoneDataService';
/* develblock:start */
import {StatsService} from '@gongxigames/framework/slot/index';
/* develblock:end */

// Settings.registerSettingsParametersSchema(CORE_SETTINGS_PARAMETERS_SCHEMA);
// Settings.registerSettingsParametersSchema(SLOT_SETTINGS_PARAMETERS_SCHEMA);

export const slotComponentsConfigV2: ComponentsConfigs = {
    services: [
        // core services
        Core.Browser,
        Core.InputGestures,
        Core.Device,
        Core.Settings,
        InitializationEnvironmentSettingsService,
        Core.EventManagerWithAsync,
        Core.SlotEventAdapter,
        // TODO
        EventBridge,
        Core.CommandLineInterfaceService,
        Core.LanguageService,
        Core.UpdateManager,
        Core.System,
        Core.ResolutionManager,
        Core.ScreenManagerV2,
        Core.ScreenManager, // TODO: remove
        Core.VisibilityManager,
        Core.ResourceLoader,
        Core.KeyboardModule,
        Core.ObjectBuilder,
        Core.DisplayObjectUtils,
        Core.FullscreenManager,
        Core.CurrencyFormatter,
        Core.SpineUtils,
        // slot services
        TemplateUtils,
        Logic,
        ResourceManager,
        SoundManager,
        SoundPlayer,
        Core.StoreSetter,
        ReelsScaleService, // TODO: remove
        ScaleService, // TODO: remove
        WinPresentationUtils,
        /* develblock:start */
        PixiJSDevtoolsService,
        StatsService,
        /* develblock:end */
        AutotestService,
        LoggerService,
        SplashScreenService,
        ReelsConstantsService,
        PrizeSymbolsUtils,
        GameInfoService,

        ...SLOT_V2_SERVICES,
        JurisdictionZoneDataService,
        ...SLOT_V2_UI_SERVICES,
    ],
    modules: [
        // initial
        Modules.SystemPopupsManager,
        Modules.MessageModule,
        LoadingScreenModuleV2,
        // Modules.IOSFullscreenModule,
        WaitingModuleV2,
        // Modules.FlowModule,
        Modules.NetworkModule,
        Modules.InactivityTimerModule,
        Modules.RealityCheckModule,

        Modules.GameSessionPromotionModule,
        Modules.SingleSetPromotionModule,
        Modules.MultiSetsPromotionModule,
        Modules.MultiSetsMulticampaignPromotionModule,

        BigWinModuleV2,
        GenericPopupModuleV2,
        disabledComponentByDefault(AnticipatorModuleV2),
        Modules.ReelsModule,
        Modules.AutoplayOptionsModule,
        // Modules.FreeSpinsModule,
        // Modules.GenericPopupModule,
        // Modules.WinPresentationModule,
        /* develblock:start */
        Modules.CheatsModule,
        Modules.RewindModule,
        /* develblock:end */
        InfoSystemModule,
        InfoPage,
        GameRules,
        GameHistoryInfoPage,
        Modules.BuyBonusButtonModule,
        Modules.BuyPopUpModule,
        Modules.BuyBonusBalanceModule,
        Modules.CoinFlightModule,
        BuyFeatureModule,
        Modules.NonMinimalBetPopup
    ],
    views: [
        // initial
        Modules.SystemPopupsView,
        // free rounds
        Modules.PromotionCounterView,

        Modules.WinPresentationView,
        // Modules.GenericPopupView,
        /* develblock:start */
        Modules.CheatsView,
        /* develblock:end */

        Modules.BuyPopUpView,
        Modules.CoinFlightView,
        Modules.BuyBonusButtonView,
        Modules.BuyBonusBalanceView,

        // mobiles views

        Modules.BuyBonusButtonViewLandscape,
        Modules.BuyBonusButtonViewPortrait,
        Modules.BuyBonusButtonViewMobile,

        Modules.BuyBonusBalanceViewLandscape,
        Modules.BuyBonusBalanceViewPortrait,
        Modules.BuyBonusBalanceViewMobile
    ]
};

// TODO remove
export function getCommonFixedScreenSizeModulesV2(): {
    modules: ComponentModuleConfig[];
    views: ComponentModuleViewConfig[];
    } {
    return {
        modules: [],
        views: []
    };
}
